// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo > span {\n  display: flex;\n  align-items: center;\n  color: white;\n}\n\n.logo {\n  padding: 0rem 1rem;\n  background: rgba(255, 255, 255, 0.2);\n  float: left;\n}\n\n.ant-layout {\n  background: #7f7fd5; /* fallback for old browsers */ /* Chrome 10-25, Safari 5.1-6 */\n  background: linear-gradient(\n  to top,\n  #001529,\n  #003b4d,\n  #006080\n);\n /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */\n}", ""]);
// Exports
module.exports = exports;
